import React, { useEffect, useState } from 'react'
import NotFound from '../../../components/not-found/NotFound'
import WcIcon from '@mui/icons-material/Wc';
import { catchMessage, elseMessage } from '../../../comman/Message'
import { getInterestedMemberListApi } from '../../../services/meetups'
import { AvatarImg } from '../../../comman/avatar/Avatar'
import ImageModal from '../../../comman/avatar/ImageModal'
import { PaginationShow } from '../../../comman/action/Pagination'
import { ViewIcon } from '../../../comman/action/ViewIcon'

const InterestedMember = ({ id }) => {

    const [memberList, setMemberList] = useState([])
    const [total, setTotal] = useState(0);
    const [page, setPage] = useState(1)
    const [showImgModal, setShowImgModal] = useState(false)
    const [imageUrl, setImageUrl] = useState('')

    // ----------open-image-in-modal-full-page------------
    const openImage = (image) => {
        setShowImgModal(image ? true : false)
        setImageUrl(image)
    }
    //*********Handel Pagination********* */
    const handlePageChange = (event) => {
        setPage(event)
    };
    //------------------listing-Api----------------------------------
    const getMemberList = async (
        meetupId = id,
        activePage = page
    ) => {
        try {
            setMemberList([])
            const res = await getInterestedMemberListApi({ meetupId, page: activePage })
            if (res?.data?.status === 200) {
                setMemberList(res?.data?.data?.membersList || [])
                setTotal(res?.data?.data?.total || 0)
            } else {
                elseMessage(res)
                setMemberList([])
            }
        } catch (err) {
            catchMessage(err)
        }
    }

    useEffect(() => {
        getMemberList(id, page)
    }, [id, page])
    return (
        <>
            <h4 className='mt-3'>Interested Member</h4>
            <div className="content-table mt-2">
                <table>
                    <thead>
                        <tr>
                            <th>S. No.</th>
                            <th>Profile</th>
                            <th>Members Name</th>
                            <th>User ID</th>
                            <th className="text-center"> Action </th>
                        </tr>
                    </thead>
                    <tbody>
                        {memberList.length > 0 ? memberList.map((
                            {
                                _id,
                                userId
                            }, index) => {
                            return (
                                <React.Fragment key={index}>
                                    <tr>
                                        <td>{++index + (page - 1) * 10}</td>
                                        <td>
                                            <AvatarImg id={_id} image={userId?.profile} openImage={openImage} />
                                        </td>
                                        <td>{userId?.name || "N/A"}</td>
                                        <td>{userId?.userName || "N/A"}</td>
                                        <td>
                                            <div className="d-flex justify-content-center">
                                                <ViewIcon to={`/user-management/view-details/${userId?._id}`} />
                                            </div>
                                        </td>
                                    </tr>
                                </React.Fragment>
                            )
                        }) :
                            <NotFound
                                cols={10}
                                msg="No Member Found!"
                                icon={<WcIcon style={{ fontSize: 48 }} />}
                            />
                        }
                    </tbody>
                </table>
            </div>
            {/* ------------pagination-------------- */}
            <PaginationShow
                total={total}
                activePage={page}
                handlePageChange={handlePageChange}
            />
            {/* --------show-img-from-api---------- */}
            <ImageModal
                showModal={showImgModal}
                closeModal={setShowImgModal}
                imageUrl={imageUrl}
            />

        </>
    )
}

export default InterestedMember